import BrowserCache from './BrowserCache';
/**
 * @typedef {Object} cacheEvent
 * @property {String} action
 * @property {String} cacheType
 * @property {String} id
 */

export const rootKey = 'ATC_RECENT_INVENTORY';
export const sixtyDaysInMs = 5184000000; // 60 * 24 * 60 * 60 * 1000

/**
 * Handles storing and caching personalization locally without authentication
 * @module InventoryCache
 */
const InventoryCache = /* #__PURE__*/(() => new BrowserCache({
  newItemKey: 'id',
  rootKey,
  maxSize: 50
}))();
export default InventoryCache;